import React from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import { useTranslation } from 'react-i18next'

import { StatusEnum } from '../../../../../data/book/data-types'
import { ChangeStatusFunction } from '../../../../../data/hooks/change-status'
import { useStatusTranslations } from '../../../../../utilities/statuses'
import { useAuth } from '../../../../../data/hooks/auth'


type ControllerProps = {
  statusId?: StatusEnum
  changeStatus: ChangeStatusFunction
}

const ChangeStatus: React.FunctionComponent<ControllerProps> = ({ statusId: status_id, changeStatus }) => {
  const { token } = useAuth()
  const statusT = useStatusTranslations()
  const { t } = useTranslation("common")

  const labels: Array<[StatusEnum, string]> = [StatusEnum.WantToRead, StatusEnum.CurrentlyReading, StatusEnum.Read].map(s => [s, statusT(s)])

  return (
    <Container>
      <Title>{t("change_status")}</Title>
      {
        labels.map(
          ([label_status_id, label]) => 
            <Status 
              key={label_status_id}
              userStatusId={status_id}
              statusId={label_status_id}
              active={status_id === label_status_id}
              preSelected={label_status_id === StatusEnum.CurrentlyReading}
              onClick={() => changeStatus(label_status_id, token?.access, false)}
            >
              {label}
            </Status>
        )
      }
    </Container>
  )
}

const Container = styled.div`
    display: grid;
    grid-template-rows: auto 1fr 1fr 1fr;
    grid-gap: 10px;
    
    width: 100%;
    padding: 10px;
    
    border-radius: 10px;
    background: ${p => p.theme.colors.bg};

    ${up('tablet')} {
      width: 350px;
    }
`

const Title = styled.div`
  height: fit-content;

  font-size: 20px;
  line-height: 30px;
  font-weight: bold;
  
  text-align: center;
`

const Status = styled.div<{ active?: boolean, userStatusId?: StatusEnum, statusId: StatusEnum, preSelected?: boolean}>`
    width: 100%;
    height: 100%;

    display: grid;
    align-items: center;
    justify-items: center;

    padding: 17px;

    border-radius: 10px;

    color: ${p => p.theme.colors.main};

    background: ${p => p.active && p.userStatusId ? p.theme.statuses[p.userStatusId] : 'none'};
    border: ${p => '1px dashed ' + p.theme.colors.serviceGray};

    text-align: center;

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */ 

    cursor: pointer;

    &:hover {
      background: ${p => p.theme.statuses[p.statusId]};
    }
`

export default ChangeStatus